import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class WebsiteServiceService {

  constructor(
    private http: HttpClient,
  ) { }
  regenerateIndividualV2(data: any) {
    return this.http.post(
      environment.regenerateUrl + `content/suggest/v2/website/individual`, data
    )
  }
}
